import CheckboxChecked16 from '@carbon/icons-react/es/checkbox--checked/16';
import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { Button } from 'components/atoms/button';
import { useTranslation } from 'hooks/use-translation';

interface ChecklistProps {
  enabled: boolean;
  onSelect: () => void;
  icon?: React.ReactNode;
}

export const Checklist: FC<ChecklistProps> = ({ enabled, onSelect, icon }) => {
  const addChecklistCaption = useTranslation('rte.plugins.checklist.add');

  return (
    <Tooltip title={addChecklistCaption}>
      <Button
        data-cy="rte.check_list.trigger"
        type="text"
        disabled={!enabled}
        aria-label={addChecklistCaption}
        icon={icon || <CheckboxChecked16 className="carbon-icon" />}
        onClick={onSelect}
      />
    </Tooltip>
  );
};
